import React from 'react';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';
import { useCJConfigurationDisplay } from '@teetsh/app/src/containers/CahierJournal/useCJConfigurationDisplay';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { getDayBasedOnWorkingDays } from '@teetsh/app/src/utils/time';
import { getMutualWorkingDays } from '@teetsh/app/src/containers/utils';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { format } from '@teetsh/app/src/utils/time/format';
import { isoDatePatternWithSlashes } from 'utils/time/datePatterns';

export function RedirectToCurrentDay() {
  const isMobile = useIsBelowBreakpoint('md');
  const { view: userView } = useCJConfigurationDisplay();
  const view = isMobile ? 'day' : userView;
  const { school, schoolyear } = useSchoolSchoolyear();
  const classrooms = useClassrooms();
  const location = useLocation();
  const day = getDayBasedOnWorkingDays(
    new Date(),
    getMutualWorkingDays(classrooms),
  );

  const { userId, token } = useParams<{
    token: string;
    userId: string;
  }>();
  const shareBaseUrl = userId && token ? `/shares/${userId}/t/${token}/` : '';
  const pathPrefix = shareBaseUrl
    ? shareBaseUrl
    : `/annee-scolaire/${schoolyear.id}/ecole/${school.id}/`;

  return (
    <Navigate
      to={`${pathPrefix}cahier-journal/${view}/${format(
        day,
        'fr-FR',
        isoDatePatternWithSlashes,
      )}${location.search}`}
      replace
    />
  );
}
